/* eslint-disable max-len */
import React from 'react';
import { Box, Flex, Image, Text, VStack } from '@chakra-ui/react';
import PageTitle from '../../components/PageTitle';
import exampleOfSusPath from '../../resources/exampleOfSus.png';
import fiveDimensionsPath from '../../resources/fiveDimensions.png';

interface SusDimenDef {
    dimension: string;
    description: string;
}

interface OrderEffectsDef {
    orderEffect: string;
    description: string;
}

const sustainableDimensionsDefinitions: SusDimenDef[] = [
    {
        dimension: 'Social',
        description: 'covers the relationships between individuals and groups.',
    },
    {
        dimension: 'Individual',
        description: "covers the individual's’ ability to thrive, exercise their rights, and develop freely.",
    },
    {
        dimension: 'Environmental',
        description: 'covers the use and stewardship of natural resources.',
    },
    {
        dimension: 'Economic',
        description: 'covers the financial aspects and business value.',
    },
    {
        dimension: 'Technical',
        description: 'covers the technical system’s ability to accommodate changes',
    },
];

const orderEffectsDefinitions: OrderEffectsDef[] = [
    {
        orderEffect: 'Immediate',
        description: 'are direct effects of the production, operation, use and disposal of socio-technical systems. This includes the properties and the full lifecycle impacts, such as in the Life-Cycle Assessment (LCA) approach.',
    },
    {
        orderEffect: 'Enabling',
        description: 'of operation and use of a system include any change enabled or induced by the system.',
    },
    {
        orderEffect: 'Structural',
        description: 'represent structural changes caused by the ongoing operation and use of the socio-technical system',
    },
];

function About() {
    return (
        <VStack>
            <PageTitle
                title="Appendix : Sustainability Awareness Framework"
            />
            <Box borderWidth="1.5px" p={8} flex={1} background="#fbfcfd">
                <Text fontSize={18}>
                    In this workshop,
                    <span style={{ fontWeight: 'bold' }}> sustainability </span>
                    is the “capacity of a socio-technical
                    system to endure”. More specifically, it refers to how systems that
                    emerge from the interaction of a technical solution with humans and
                    their environment can endure within the current economic,
                    environmental, social, technical and individual settings. These are
                    commonly referred to as the five dimensions of sustainability.
                </Text>
                <br />
                <Box borderWidth="1.5px" p={4} flex={1} background="#fbfcfd">
                    <Text fontSize={18}>
                        <span style={{ fontWeight: 'bold' }}> Example: </span>
                        Airbnb is a platform that offers a peer-to-peer short-term
                        accommodation. In New York, homeowners can earn 55% more than the
                        median long-term rental in the same neighbourhood (affecting the
                        individuals and the economy). As a consequence, it is estimated that
                        Airbnb has removed between 7,000 and 13,000 units of housing in New
                        York from the long-term rental market, leading to an increase of
                        1.4% in the median long-term rent (affecting the society and the
                        economy) and gentrification in areas where 72% are non-white, also
                        increasing the race separations across the city (affecting the
                        society).
                    </Text>
                    <br />
                </Box>
                <br />
                <Text fontSize={18}>
                    The
                    {' '}
                    <span style={{ fontWeight: 'bold' }}> Sustainability Awareness Framework (SusAF) </span>
                    is a tool that supports stakeholders with different viewpoints to start a conversation on the
                    possible effects of a socio-technical system on sustainability. It aims to raise awareness on the relationship between software and
                    sustainability; a comprehensive sustainability impact analysis requires further work.
                </Text>
                <br />
                <Text fontSize={18}>
                    The SusAF is concerned with five
                    <span style={{ fontWeight: 'bold' }}> dimensions of sustainability </span>
                    and the three
                    <span style={{ fontWeight: 'bold' }}> order of effects: </span>
                </Text>
                <br />
                <Flex>
                    <Box
                        borderWidth="1.5px"
                        p={4}
                        flex={1}
                        background="#fbfcfd"
                        marginRight="5px"
                    >
                        <Text style={{ fontWeight: 'bold' }}>Definition of Sustainability Dimensions</Text>
                        <br />
                        {sustainableDimensionsDefinitions.map((def) => (
                            <Text key={def.dimension}>
                                <span style={{ fontWeight: 'bold', color: '#045981' }}>
                                    {`${def.dimension}: `}
                                </span>
                                <span style={{ color: 'black' }}>
                                    {def.description}
                                </span>
                            </Text>
                        ))}
                    </Box>
                    <Box
                        borderWidth="1.5px"
                        p={4}
                        flex={1}
                        background="#fbfcfd"
                        marginRight="5px"
                    >
                        <Text style={{ fontWeight: 'bold' }}>Definition of the order effects</Text>
                        <br />
                        {orderEffectsDefinitions.map((def) => (
                            <Text key={def.orderEffect}>
                                <span style={{ fontWeight: 'bold', color: '#045981' }}>
                                    {`${def.orderEffect}: `}
                                </span>
                                <span style={{ color: 'black' }}>
                                    {def.description}
                                </span>
                            </Text>
                        ))}
                    </Box>
                </Flex>
                <Box p={4} flex={1} background="#fbfcfd">
                    <Text fontSize={18}>
                        The SusAF
                        <span style={{ fontWeight: 'bold' }}> questions sheets </span>
                        and the
                        <span style={{ fontWeight: 'bold' }}> Sustainability Awareness Diagram </span>
                        (SusAD) for guiding  discussion on the potential effects of technical systems and visualizing potential chains  of effects.
                    </Text>
                    <br />
                </Box>
                <Flex background="white">
                    <Box
                        p={4}
                        flex={1}
                        marginRight="5px"
                    >
                        <Image
                            src={fiveDimensionsPath}
                            alt="five-dimensions"
                        />
                    </Box>
                    <Box
                        p={4}
                        flex={1}
                        marginRight="5px"
                    >
                        <Image
                            src={exampleOfSusPath}
                            alt="sus-example"
                        />
                    </Box>
                </Flex>
            </Box>
        </VStack>
    );
}

export default About;
